import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationConfig } from '@config/application.config';
import { Constant } from '@common/constant';
import { ApplicationModel } from 'app/model/application.model';

@Injectable()
export class AppVersionInterceptor implements HttpInterceptor {

  constructor(private applicationModel: ApplicationModel) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method && (request.url?.indexOf(ApplicationConfig.apiUrl) > -1)) {
      const appVersionRequest: HttpRequest<any> = request.clone({
        setHeaders: {
          [Constant.HTTP_APP_VERSION_HEADER]: this.applicationModel.appVersion
        }
      });

      return next.handle(appVersionRequest);
    } else {
      return next.handle(request);
    }
  }
}
